/* unplugin-vue-components disabled */import { render } from "./tech.vue?vue&type=template&id=ea5b4244&scoped=true"
import script from "./tech.vue?vue&type=script&lang=js"
export * from "./tech.vue?vue&type=script&lang=js"

import "./tech.vue?vue&type=style&index=0&id=ea5b4244&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea5b4244"]])

export default __exports__